<template>
  <div class="uk-grid uk-child-width-1-1" data-uk-grid>
    <div>
      <div class="uk-flex uk-flex-between uk-flex-middle">
        <div>
          <h1 class="uk-h4 uk-margin-remove">
            <span>
              <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-edit" width="24" height="24"
                viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" fill="none" stroke-linecap="round"
                stroke-linejoin="round">
                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                <path d="M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1"></path>
                <path d="M20.385 6.585a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3l8.385 -8.415z"></path>
                <path d="M16 5l3 3"></path>
              </svg>
            </span>
            {{ headerLabel }}
          </h1>
        </div>
        <div>
          <a @click.prevent="$router.go(-1)" class="uk-button uk-button-small uk-button-text">
            <span class="uk-margin-small-right uk-icon" uk-icon="icon: arrow-left"></span>
            Zurück
          </a>
        </div>
      </div>
    </div>
    <div>
      <ul uk-tab>
        <li><a href="#">Fahrzeugdaten</a></li>
        <li v-if="vehicleId"><a href="#">Angebote</a></li>
      </ul>
      <ul class="uk-switcher uk-margin">
        <li>
          <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
            <div class="uk-grid" data-uk-grid>
              <div class="uk-width-expand@m">
                <div class="uk-card uk-card-small uk-card-default uk-box-shadow-small uk-margin-bottom">
                  <div class="uk-card-body">
                    <div class="uk-grid" data-uk-grid>
                      <div class="uk-width-1-1">
                        <div class="uk-grid" uk-grid>
                          <div class="uk-width-1-1">
                            <div class="uk-margin">
                              <make-models placeholder="Beliebig" :selected="selectedMakeModels" :makes="makeModels"
                                @change="onMakeModelChange" :formErrors="formErrors">
                              </make-models>
                            </div>
                            <div class="uk-margin">
                              <label class="uk-form-label" for="edition">Edition</label>
                              <div class="uk-form-controls">
                                <input class="uk-input" name="edition" type="text" v-model="form.edition" />
                              </div>
                            </div>
                            <div class="uk-margin">
                              <div class="uk-grid uk-grid-small uk-child-width-1-2@m" data-uk-grid>
                                <div>
                                  <label for="fueltype" class="uk-form-label">Kraftstoff</label>
                                  <div class="uk-form-controls">
                                    <v-select :options="fueltypes" v-model="form.fueltype" :searchable="false"
                                      :reduce="filter => filter.value" placeholder="Kraftstoff wählen"></v-select>
                                      <span v-if="formErrors['fueltype']" class="uk-text-small uk-text-danger">{{ formErrors['fueltype'] }}</span>
                                  </div>
                                </div>
                                <div>
                                  <label class="uk-form-label" for="powerKw">Leistung kW</label>
                                  <div class="uk-form-controls">
                                    <input class="uk-input" name="powerKw" type="text" v-model="form.powerKw" />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="uk-margin">
                              <div class="uk-grid uk-grid-small uk-child-width-1-2@m" data-uk-grid>
                                <div>
                                  <label class="uk-form-label" for="price">UPE netto</label>
                                  <div class="uk-form-controls">
                                    <currency-input v-model="form.price" class="uk-input" value-as-integer
                                      :distraction-free="{
                                        hideCurrencySymbol: true
                                      }"></currency-input>
                                  </div>
                                </div>
                                <div>
                                  <label class="uk-form-label" for="shippingCosts">Frachtkosten netto</label>
                                  <div class="uk-form-controls">
                                    <currency-input v-model="form.shippingCosts" class="uk-input" value-as-integer
                                      :distraction-free="{
                                        hideCurrencySymbol: true
                                      }"></currency-input>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="uk-margin">
                              <label class="uk-form-label" for="description">Beschreibung</label>
                              <div class="uk-form-controls">
                                <textarea rows="10" class="uk-textarea" name="description" type="text"
                                  v-model="form.description" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
              <div class="uk-width-1-3@m">
                <div class="uk-card uk-card-small uk-card-default uk-box-shadow-small uk-margin-bottom">
                  <div class="uk-card-body">
                    <div class="uk-margin" v-if="vehicleId">
                      <label class="uk-form-label" for="description">Angebotsnummer</label>
                      <div class="uk-form-controls">
                        <input class="uk-input" disabled type="text" v-model="form.number" />
                      </div>
                    </div>
                    <div class="uk-margin">
                      <label class="uk-form-label" for="description">Startdatum</label>
                      <div class="uk-form-controls">
                        <v-date-picker :input-props="{ class: 'uk-input' }" v-model="startDate"
                          :attributes="datepickerAttr" title-position="left" :popover="{ visibility: 'click' }" />
                      </div>
                    </div>
                    <div class="uk-margin">
                      <label class="uk-form-label" for="description">Enddatum</label>
                      <div class="uk-form-controls">
                        <v-date-picker :input-props="{ class: 'uk-input' }" v-model="endDate" :attributes="datepickerAttr"
                          title-position="left" :popover="{ visibility: 'click' }" />
                      </div>
                    </div>
                    <div class="uk-margin">
                      <label class="uk-form-label" for="availableQuantity">Verfügbares Volumen insgesamt</label>
                      <div class="uk-form-controls">
                        <input class="uk-input" name="availableQuantity" type="text" v-model="form.availableQuantity" />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="uk-width-1-1">
                  <div class="uk-align-right">
                    <button type="submit" class="uk-button uk-button-primary uk-margin-small-left" :disabled="isSending"
                      @click.prevent="handleSubmit(store)">
                      <div v-if="isSending" data-uk-spinner="ratio: 0.7" class="uk-margin-small-right"></div>
                      Speichern
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </ValidationObserver>
        </li>
        <li v-if="vehicleId && form.offers">
          <Offers :offers="form.offers" :shipping-costs="form.shippingCosts" :price="form.price"
            :available-quantity="form.availableQuantity" />
          <div v-if="!form.offers.length">
            Noch keine Angebote vorhanden!
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import MakeModels from '../../../../components/search/MakeModels.vue'
import Offers from '@/components/admin/exchange/Offers.vue'
import ExchangeService from '@/services/exchange.service'
import 'izitoast/dist/css/iziToast.min.css'
import iziToast from 'izitoast/dist/js/iziToast.min.js'
import { ValidationObserver, extend } from 'vee-validate'
import { required } from 'vee-validate/dist/rules'
import moment from 'moment'

extend('required', {
  ...required,
  message: 'Pflichtfeld'
})

export default {
  components: {
    ValidationObserver,
    MakeModels,
    Offers
  },
  data() {
    return {
      formErrors: [],
      vehicleId: this.$route.params.id,
      isSending: false,
      selectedMakeModels: {
        make: null,
        model: null
      },
      makeModels: [],
      fueltypes: [],
      form: {
        make: '',
        model: '',
        fueltype: '',
        powerKw: '',
        price: 0,
        description: '',
        shippingCosts: 0,
        availableQuantity: 0,
        startDate: moment().format('YYYY-MM-DD'),
        endDate: moment()
          .add(30, 'days')
          .format('YYYY-MM-DD'),
      },
      datepickerAttr: [
        {
          dot: true,
          dates: new Date()
        }
      ]
    }
  },
  computed: {
    headerLabel() {
      return this.vehicleId ? 'Fahrzeug bearbeiten' : 'Fahrzeug anlegen'
    },
    startDate: {
      get() {
        return this.form.startDate ? new Date(this.form.startDate) : null
      },
      set(value) {
        this.form.startDate = value ? moment(value).format('YYYY-MM-DD') : null
      }
    },
    endDate: {
      get() {
        return this.form.endDate ? new Date(this.form.endDate) : null
      },
      set(value) {
        this.form.endDate = value ? moment(value).format('YYYY-MM-DD') : null
      }
    }
  },
  mounted() {
    this.getMakeModels()
    this.getFueltypes()
    if (this.vehicleId) {
      this.getVehicle()
    }
  },
  methods: {
    getVehicle() {
      ExchangeService.getVehicle(this.vehicleId).then(response => {
        this.form = response.data
        this.selectedMakeModels.make = response.data.make
        this.selectedMakeModels.model = response.data.model
      })
    },
    getMakeModels() {
      ExchangeService.getMakeModels().then(response => {
        this.makeModels = response.data
      })
    },
    getFueltypes() {
      ExchangeService.getFueltypes().then(response => {
        this.fueltypes = response.data
      })
    },
    async store() {
      this.formErrors = []
      this.isSending = true
      try {
        let response = null
        if (this.vehicleId) {
          response = await ExchangeService.updateVehicle(this.vehicleId, this.form)
        } else {
          response = await ExchangeService.storeVehicle(this.form)
        }
        iziToast.success({
          title: 'OK',
          message: 'Fahrzeug gespeichert!',
          timeout: 3000,
          position: 'topCenter'
        })
        this.isSending = false
        if(!this.vehicleId) {
          this.$router.replace({
            name: 'admin.exchange.vehicle.edit',
            params: {
              id: response.data.id
            }
          })
        }
      } catch (error) {
        this.isSending = false
        let message = 'Es ist ein Fehler aufgetreten!'
        if (error.response.status === 400) {
          message ='Bitte Pflichtfelder beachten!'
          this.formErrors = error.response.data.errors
        }
        iziToast.error({
          title: 'Fehler',
          message: message,
          timeout: 5000,
          position: 'topCenter'
        })
      }
    },
    onMakeModelChange(data) {
      this.form.make = data.make
      this.form.model = data.model
    },
  }
}
</script>